"use client"

import React, { useState } from "react"
import { loadRefreshedBaskeAction } from "@/actions/basketActions"
import { useUbStorefrontState } from "@/store/ubStorefrontState"
import { useTranslations } from "next-intl"

import { cn } from "@/lib/utils"
import { Label, Select, SelectContent, SelectItem, SelectTrigger, Switch } from "@/components/ui/components"
import StoryblokCustomerTypeDialogClient from "@/components/storyblok/header/StoryblokCustomerTypeDialogClient"

export default function StoryblokPrivateCustomerToggle({ isB2BCustomer, userData, isMobileVisible = false }) {
  const [dialogVisible, setDialogVisible] = useState<boolean>(false)
  const { setIsLoading, setBasketData } = useUbStorefrontState()

  const t = useTranslations("storefront")

  function handleOnClose() {
    setDialogVisible(false)
    setIsLoading(true)
    setTimeout(() => {
      setIsLoading(false)
    }, 2000)

    loadRefreshedBaskeAction().then((basketData) => {
      setBasketData(basketData)
      const url = new URL(window.location.href)
      //console.log(url.href)
      //UBW-833 remove all combinations of params 'b2c' when switching customer type
      url.searchParams.delete("b2c")
      url.searchParams.delete("B2C")
      url.searchParams.delete("b2C")
      url.searchParams.delete("B2c")
      window.location.href = url.href
    })
  }

  return (
    <>
      {dialogVisible && <StoryblokCustomerTypeDialogClient onClose={handleOnClose} />}

      {!userData &&
        (isMobileVisible ? (
          <div className="flex items-center space-x-2">
            <Label
              htmlFor="business-customer-mode"
              className={cn("tracking-tight xl:tracking-normal", {
                "font-bold": isB2BCustomer,
              })}
            >
              {t("customer.b2b")}
            </Label>
            <Switch
              aria-labelledby="business-customer-mode"
              id="business-customer-mode"
              checked={!isB2BCustomer}
              onCheckedChange={() => setDialogVisible(true)}
            />
            <Label
              htmlFor="business-customer-mode"
              className={cn("tracking-tight xl:tracking-normal", {
                "font-bold": !isB2BCustomer,
              })}
            >
              {t("customer.b2c")}
            </Label>
          </div>
        ) : (
          <div className="flex items-center space-x-2">
            <Select value={isB2BCustomer ? "b2b" : "b2c"} onValueChange={() => setDialogVisible(true)}>
              <SelectTrigger
                className="h-6 border-none p-0 text-xs font-bold text-black"
                aria-label={t("customer.b2b") + " | " + t("customer.b2c")}
              >
                {isB2BCustomer ? t("customer.b2b") : t("customer.b2c")}
              </SelectTrigger>
              <SelectContent className={"bg-white"}>
                {!isB2BCustomer && (
                  <SelectItem className="bg-white p-1 text-xs font-bold" value="b2b" aria-label={t("customer.b2b")}>
                    {t("customer.b2b")}
                  </SelectItem>
                )}
                {isB2BCustomer && (
                  <SelectItem className="bg-white p-1 text-xs font-bold" value="b2c" aria-label={t("customer.b2c")}>
                    {t("customer.b2c")}
                  </SelectItem>
                )}
              </SelectContent>
            </Select>
          </div>
        ))}
    </>
  )
}
